export const PHONE_NUMBER_FORM = {
  TITLE: "اهلا بك في وفي, ادخل رقم جوالك",
  SUB_TITLE: "سوف نقوم بتأكيد رقم جوالك للدخول الي حسابك",
  ERROR: "من فضلك ادخل رقمك الهاتفي الصحيح",
  WRONG_NUMBER: "رقم الهاتف غير صحيح",
};

export const OTP_FORM = {
  TITLE: "اهلا بك في وفي, ادخل رقم جوالك",
  SUB_TITLE: "ادخل رمز التحقيق, تم ارسال الرمز الي",
  CHANE_NUMBER: "تغيير الرقم",
  SEND_AGAIN: "اعادة الارسال خلال",
  TIME: "00.20",
  ERROR: "رمز التحقق غير صحيح, تأكد من الرمز المرسل و أعد ادخاله",
};
export const SECURITY_CODE_FORM = {
  TITLE: "قم بإدخال رمز الأمان",
  SUB_TITLE: " أدخل رمز الأمان الخاص بحسابك.",
  ERROR: "رمز الامان غير صحيح",
};

export const LOGIN = "تسجيل الدخول";
export const CONFIRM = "تأكيد";
export const SKIP = "تخطي";
export const CONTINUE = "متابعة";

export const LOGIN_RESPONSE_ERROR = "خطأ في رقم الهاتق او رمز الامان";
export const USER_DEACTIVATED_RESPONSE_ERROR =
  "لا يمكنك الدخول لحسابك، تواصل معنا";

export const RESET_PHONE_NUMBER_FORM = {
  TITLE: "إعادة تعيين رمز الأمان",
  SUB_TITLE: "أدخل رقم الجوال الخاص بحسابك، لإعادة تعيين رمز الأمان.",
  ERROR: "من فضلك ادخل رقمك الهاتفي الصحيح",
  WRONG_NUMBER: "رقم الهاتف غير صحيح",
};

export const RESET_OTP_FORM = {
  TITLE: "إعادة تعيين رمز الأمان",
  SUB_TITLE: "أدخل رمز التحقق، ﺗﻢ إرﺳﺎل اﻟﺮﻣﺰ إلى ",
  CHANE_NUMBER: "تغيير الرقم",
  SEND_AGAIN: "اعادة الارسال خلال",
  TIME: "00.20",
  ERROR: "رمز التحقق غير صحيح, تأكد من الرمز المرسل و أعد ادخاله",
};
export const RESET_SECURITY_CODE_FORM = {
  TITLE: "رمز الأمان الجديد",
  SUB_TITLE: "ﺳﻨﻄﻠﺒﻪ ﻣﻨﻚ ﻟﺘﺄﻛﻴﺪ أى ﻣﻌﺎﻣﻠﺔ ﺗﻘﻮم ﺑﻬﺎ، هذا المدخل يقبل أرقام فقط.",
  SECOND_SUB_TITLE: "أعد إدخال رمز الأمان",
  ERROR: "رمز الامان غير صحيح",
};
